/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Events_Ordered_By_TimeInputs */



/**
* | output |
* | --- |
* | "Events ordered by time successfully" |
*
* @param {Events_Ordered_By_TimeInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const events_ordered_by_time = /** @type {((inputs?: Events_Ordered_By_TimeInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Events_Ordered_By_TimeInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Événements triés par temps avec succès")
	if (locale === "de") return /** @type {LocalizedString} */ ("Ereignisse erfolgreich nach Zeit sortiert")
	if (locale === "it") return /** @type {LocalizedString} */ ("Eventi ordinati correttamente in base al tempo")
	if (locale === "ru") return /** @type {LocalizedString} */ ("События успешно упорядочены по времени.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Eventos ordenados por tiempo con éxito")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("按时间排序的事件成功")
	if (locale === "ja") return /** @type {LocalizedString} */ ("イベントは時間順に並べられました")
	if (locale === "hi") return /** @type {LocalizedString} */ ("समय के अनुसार क्रमबद्ध की गई घटनाएँ सफलतापूर्वक")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Eventos ordenados por tempo com sucesso")
	return /** @type {LocalizedString} */ ("Events ordered by time successfully")
});